import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import { useContext } from "react";
import { Context } from "./context/Context";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Vision from "./components/Vision";
import Team from "./components/Team";
import Blogs from "./components/Blog";
import TermsAndConditions from "./components/TermsAndConditions";
import ScrollToTop from "./components/ScrollToTop";
import ContactPage from "./pages/ContactPage";

const App = () => {

  const { auth } = useContext(Context);
  
  return (
    <BrowserRouter> 
    <ScrollToTop />
    <Header />
      <Routes>
       
        <Route path="/" element={<Home/>} />
        <Route path="/auth" element={auth?<Account/>:<Auth/>} />
        <Route path="/vision" element={<Vision/>} />
        <Route path="/team" element={<Team/>} />
        <Route path="/blog" element={<Blogs/>} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions/>} />
        <Route path="/contact" element={<ContactPage/>} />
        {/* <Route path="/account" element={<Account/>} /> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;